import axios from "axios"

export const axiosInstance = axios.create({
  headers: {
    "X-Platform": "WEB",
    Accept: "application/poznejme-cesko-v1+json",
  },
})
